import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const getters = {
    hasTransaction: state => {
        return state.transaction.id !== null;
    },

    hasTable: state => {
        return state.transaction.order.table !== null;
    },

    receipt: state => {
        return state.transaction.receipt;
    },

    isVoided: state => {
        return state.transaction.receipt.voided_at !== null;
    },

    table: state => {
        let table = state.transaction.order.table;
        if (table != null) return table.table;
        else return null;
    },

    order: state => {
        return state.transaction.order;
    },

    orderTable: state => {
        return state.transaction.order.table;
    },

    /**
     * @return {Array}
     */
    orderProducts: state => {
        return state.transaction.order.products;
    },

    transaction: state => {
        return state.transaction;
    },

    outlet: state => {
        return state.transaction.receipt.outlet;
    },

    cashier: state => {
        return state.transaction.receipt.cashier;
    },

    charges: state => {
        return state.transaction.receipt.charges;
    },

    taxes: state => {
        return state.transaction.receipt.taxes;
    },

    voider: (state, getters) => {
        return getters.receipt.voided_staff;
    },

    /**
     * @return {Array}
     */
    discounts: state => {
        let receiptDiscounts = state.transaction.receipt.discounts;

        return receiptDiscounts.map(obj => {
            let name =
                obj.discount == null
                    ? obj.name
                        ? obj.name
                        : obj.remarks
                    : obj.discount.name;

            return {
                name: name,
                amount: obj.amount,
                remarks: obj.remarks,
            };
        });
    },

    payments: state => {
        let receiptPayments = state.transaction.receipt.payments;
        return receiptPayments.map(obj => {
            return {
                name: obj.payment.name,
                amount: numeral(parseFloat(obj.amount)).format(),
                reference_number: obj.reference_number,
            };
        });
    },

    /**
     * @return {Float}
     */
    totalDiscount: state => {
        let receiptDiscounts = state.transaction.receipt.discounts;
        let totalDiscount = 0;

        receiptDiscounts.forEach(obj => {
            totalDiscount += parseFloat(obj.amount);
        });

        return totalDiscount;
    },

    totalAfterDiscount: (state, getters) => {
        return numeral(
            parseFloat(getters.receipt.amount) + getters.totalDiscount,
        ).format();
    },

    amountFormatted: (state, getters) => {
        return numeral(parseFloat(getters.receipt.amount)).format();
    },

    totalAmountFormatted: (state, getters) => {
        return numeral(parseFloat(getters.receipt.total_amount)).format();
    },

    taxesFormatted: state => {
        return state.transaction.receipt.taxes.map(tax => {
            return {
                ...tax,
                amountFormatted: numeral(parseFloat(tax.amount)).format(),
            };
        });
    },
    chargesFormatted: state => {
        return state.transaction.receipt.charges.map(charge => {
            return {
                ...charge,
                amountFormatted: numeral(parseFloat(charge.amount)).format(),
            };
        });
    },
    totalChangeFormatted: (state, getters) => {
        let totalChange = 0;
        getters.receipt.payments.forEach(p => {
            totalChange += !_.isNull(p.change) ? parseFloat(p.change) : 0;
        });
        return numeral(totalChange).format();
    },
    /**
     * @return {Float}
     */
    totalChange: (state, getters) => {
        let totalChange = 0;

        getters.receipt.payments.forEach(p => {
            totalChange += !_.isNull(p.change) ? parseFloat(p.change) : 0;
        });

        return numeral(totalChange).format();
    },

    firstTransaction: state => state.firstTransaction,

    currency: (state, getters) => {
        const preference = getters.outlet.preference;

        if (preference && preference.currency) {
            return preference.currency.symbol;
        }

        return 'RM';
    },
};

const state = {
    transaction: {
        id: null,
        receipt: {
            discounts: [],
            payments: [],
            taxes: [],
        },
        order: {
            products: [],
            table: {
                table: null,
            },
        },
    },

    firstTransaction: null,
};

const mutations = {
    [type.SET_TRANSACTION](state, transaction) {
        state.transaction = transaction;
    },

    setFirstTransaction(state, data) {
        state.firstTransaction = data;
    },
};

const actions = {
    getTransaction({ dispatch, commit }, id) {
        startLoading(dispatch, 'fetch-transaction');

        let url = Laroute.route(
            'franchise.report.transaction.getTransactionReceipt',
            { id: id },
        );

        axios
            .get(url)
            .then(res => {
                endLoading(dispatch, 'fetch-transaction');

                let data = res.data.data;
                commit(type.SET_TRANSACTION, data);

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-transaction');

                throw err;
            });
    },

    getPublicTransaction(
        { dispatch, commit },
        { franchise_id, transaction_id },
    ) {
        startLoading(dispatch, 'fetch-transaction');
        let url = `/e-invoice/receipt/${franchise_id}/${transaction_id}`;
        return axios
            .get(url)
            .then(res => {
                endLoading(dispatch, 'fetch-transaction');
                let data = res.data.data;
                commit(type.SET_TRANSACTION, data);
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-transaction');
                throw err;
            });
    },

    async getFirstTransaction({ dispatch, commit }, outletId) {
        startLoading(dispatch, 'first-transaction');

        let url = Laroute.route('franchise.report.transaction.first', {
            outletId,
        });

        axios
            .get(url)
            .then(res => {
                endLoading(dispatch, 'first-transaction');

                commit('setFirstTransaction', res.data);

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'first-transaction');

                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/transaction.js